import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class FloorService {

    static addFloor = (id, data) => {
        return axios.post(`${PATH.ADD_FLOOR}/${id}`, data);
    }

    static getFloorList = (id, params) => {
        return axios.get(`${PATH.GET_FLOOR_LIST}/${id}`, {params});
    }

    static getFloorTypeList = id => {
        return axios.get(`${PATH.GET_FLOOR_TYPE_LIST}/${id}`);
    }

    static editFloor = (data, id, restaurantId) => {
        return axios.put(`${PATH.EDIT_FLOOR}/${id}/${restaurantId}`, data);
    }

}
